export const CALCULATOR_LABELS: Record<string, string> = {
  'cd-calculator': 'CD Calculator',
  'compound-interest-calculator': 'Compound Interest Calculator',
  'interest-calculator': 'Interest Calculator',
  'savings-apy-boost-calculator': 'Savings APY Boost Calculator',
  'savings-calculator': 'Savings Calculator',
};
